import React from 'react';
import { withNavItem } from 'react-skeletal-nav';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { prismicImage } from 'src/common/utils/prismic-image';

import isHexColor from '../../../utils/is-hex-color';

import './ExpandedNavItem.scss';

const ExpandedNavItem = ({
  image,
  imageBackground = 'blue-light',
  imageSize,
  imageFullWidth,
  title,
  description,
  href
}) => {
  const backgroundIsHexColor = isHexColor(imageBackground);

  return (
    <li className="expanded-nav-item">
      <a className="expanded-nav-item__link" href={href}>
        <div
          className={cx('expanded-nav-item__image', {
            [`color-bg-${imageBackground}`]: !backgroundIsHexColor,
            'expanded-nav-item__image--full-width': imageFullWidth
          })}
          style={{
            backgroundColor: backgroundIsHexColor ? imageBackground : undefined
          }}>
          {image && (
            <div
              className="expanded-nav-item__image-inner"
              style={{
                backgroundImage: `url(${prismicImage(image)})`,
                backgroundSize: imageSize
              }}
            />
          )}
        </div>
        <div className="expanded-nav-item__body">
          <div className="expanded-nav-item__title text-mega">{title}</div>
          <div className="expanded-nav-item__description text-base">
            {description}
          </div>
        </div>
      </a>
    </li>
  );
};

ExpandedNavItem.propTypes = {
  href: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,
  imageBackground: PropTypes.string,
  imageSize: PropTypes.string.isRequired,
  imageFullWidth: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default withNavItem(ExpandedNavItem);
